import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import Header from './Header';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="admin-layout">
      <div className={`sidebar-wrapper ${sidebarOpen ? 'open' : 'closed'}`}>
        <Sidebar />
      </div>
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Header toggleSidebar={toggleSidebar} />
        <Container fluid className="py-4 px-4">
          {children}
        </Container>
      </div>

      <style jsx>{`
        .admin-layout {
          display: flex;
          min-height: 100vh;
        }

        .sidebar-wrapper {
          width: 250px;
          transition: all 0.3s ease;
          position: fixed;
          height: 100vh;
          z-index: 1000;
        }

        .sidebar-wrapper.closed {
          width: 0;
          overflow: hidden;
        }

        .main-content {
          flex: 1;
          transition: all 0.3s ease;
          margin-left: 250px;
        }

        .main-content.sidebar-closed {
          margin-left: 0;
        }

        @media (max-width: 768px) {
          .sidebar-wrapper {
            margin-left: -250px;
          }
          
          .sidebar-wrapper.open {
            margin-left: 0;
          }
          
          .main-content {
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default AdminLayout;